import { Outlet } from "react-router-dom";

import { FilterCardSeriesProvider } from "./filter-card-series/filter-card-series.context";
import './card-series.scss';

export function CardSeries() {
  return (
    <div id="ShellCardSeries" className="card-series">
       <FilterCardSeriesProvider>
        <Outlet />
      </FilterCardSeriesProvider>
    </div>
  );
}

export default CardSeries;
